import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Legacy redirect: the standalone install detail page has been folded into
 * the unified agent detail (CLA-419). An agent's id IS its install id
 * (`agent_installations` row), so the same path param maps straight through.
 *
 * @since 1.0.0
 */
export const Route = createFileRoute("/clawinstall/admin/installs/$installId")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/clawinstall/admin/agents/$agentId",
      params: { agentId: params.installId },
    });
  },
});
